import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';

@Component({
  selector: 'app-manual-payment-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './manual-payment-card.component.html',
  styleUrl: './manual-payment-card.component.scss',
})
export class ManualPaymentCardComponent {
  isSelected = input(false);
  disabled = input(false);
  payWithPSE = output<void>();
}
